import styled from 'styled-components';

import PrivacySection from '_components/composed/sections/PrivacySection';

const StyledPrivacyPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PrivacyPage = () => {
  return (
    <StyledPrivacyPage>
      <PrivacySection />
    </StyledPrivacyPage>
  );
};

export default PrivacyPage;
